import script from "./Help.vue?vue&type=script&setup=true&lang=ts"
export * from "./Help.vue?vue&type=script&setup=true&lang=ts"

import "./Help.vue?vue&type=style&index=0&id=6e8792eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e8792eb"]])

export default __exports__